// Combined tasks module assembled from smaller focused helpers.
import { fetchTasks } from "./fetch";
import { mutationsTasks } from "./mutations";
import { regularTasks } from "./regular";
import { deferredTasks } from "./deferred";
import { dependenciesTasks } from "./dependencies";

const tasksModule = {
  ...fetchTasks,
  ...mutationsTasks,
  ...regularTasks,
  ...deferredTasks,
  ...dependenciesTasks,
};

export type TasksModule = typeof tasksModule;

export function registerTasks(db: { tasks?: TasksModule }) {
  db.tasks = tasksModule;
}

export { tasksModule as tasks };
